﻿import Masonry from "masonry-layout";
import "./gallerycategory-dropdown.svelte";

for (let element of document.querySelectorAll<HTMLElement>(".gallery-category__items")) {
	setTimeout(() => {
		new Masonry(element, {
			itemSelector: ".gallery-item",
			gutter: ".gallery-category__gap-sizer",
			horizontalOrder: true,
		});
	}, 0);
}
